{
  "version": 1,
  "asset_id": "e45358b6-8d2d-40bf-9ae2-d205e4506318",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e45358b6-8d2d-40bf-9ae2-d205e4506318/sleeve-to-bypass-first-view-en-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e45358b6-8d2d-40bf-9ae2-d205e4506318/sleeve-to-bypass-first-view-en-640.webp",
  "original_filename": "sleeve-to-bypass-first-view-en-640.webp",
  "size": 28172,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:33:50Z"
}
